module.exports = __webpack_public_path__ + "static/media/bagicon.aa54c8df.svg";